var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import { CautionCircleFilled, CloseCircleFilled, CheckCircleFilled, LeftOutlined, SortOutlined, } from 'msb-icons-svg/lib/src';
import RcSteps from 'rc-steps';
import * as React from 'react';
import AffixFC from '../affix';
import Button from '../button';
import Collapse from '../collapse';
import { ConfigContext } from '../config-provider';
import { Col, Row } from '../grid';
import useBreakpoint from '../grid/hooks/useBreakpoint';
import Progress from '../progress';
import Typography from '../typography';
const Steps = props => {
    var _a, _b;
    const { percent, size, className, direction, responsive, labelPlacement = 'vertical', children, current, isMobile, mobileTop, onPrevStep, onChange } = props, restProps = __rest(props, ["percent", "size", "className", "direction", "responsive", "labelPlacement", "children", "current", "isMobile", "mobileTop", "onPrevStep", "onChange"]);
    const { xs } = useBreakpoint(responsive);
    const { getPrefixCls, direction: rtlDirection } = React.useContext(ConfigContext);
    const [mobileShowStep, setMobileShowStep] = React.useState(0);
    const [mobileCurrentStep, setMobileCurrentStep] = React.useState(0);
    const [lastStepHasStatus, setLastStepHasStatus] = React.useState(-1);
    const getDirection = React.useCallback(() => (responsive && xs ? direction || 'vertical' : direction), [xs, direction]);
    const prefixCls = getPrefixCls('steps', props.prefixCls);
    const iconPrefix = getPrefixCls('', props.iconPrefix);
    const icons = {
        finish: React.createElement(CheckCircleFilled, { className: `${prefixCls}-finish-icon` }),
        error: React.createElement(CloseCircleFilled, { className: `${prefixCls}-error-icon` }),
        pending: (React.createElement(CautionCircleFilled, { style: { lineHeight: '20px' }, className: `${prefixCls}-pending-icon` })),
    };
    const handleChange = (item) => {
        if (onChange) {
            onChange(item);
        }
    };
    const mobileToggle = () => {
        setMobileShowStep(mobileShowStep ? 0 : 1);
    };
    const handlePreStep = (event) => {
        event.stopPropagation();
        if (onPrevStep) {
            onPrevStep(current || 0);
        }
        else if (mobileCurrentStep) {
            setMobileCurrentStep(mobileCurrentStep - 1);
            if (onChange)
                onChange(mobileCurrentStep);
        }
    };
    const stepIconRender = ({ node, status, index, }) => {
        if (status !== 'process' && status !== 'wait') {
            setLastStepHasStatus(index);
        }
        if (status === 'process' && percent !== undefined) {
            // currently it's hard-coded, since we can't easily read the actually width of icon
            // MSB override
            const progressWidth = size === 'small' ? 26 : 26;
            // MSB override
            const iconWithProgress = (React.createElement("div", { className: `${prefixCls}-progress-icon` },
                React.createElement(Progress, { type: "circle", percent: percent, width: progressWidth, strokeWidth: 4, format: () => null }),
                node));
            return iconWithProgress;
        }
        if (status === 'pending') {
            return (React.createElement("span", { className: `${prefixCls}-icon` },
                React.createElement(CautionCircleFilled, { className: `${prefixCls}-pending-icon` })));
        }
        return node;
    };
    const childStep = React.Children.toArray(children);
    const numSteps = childStep === null || childStep === void 0 ? void 0 : childStep.length;
    const stepsClassName = classNames({
        [`${prefixCls}-rtl`]: rtlDirection === 'rtl',
        [`${prefixCls}-with-progress`]: percent !== undefined,
        [`${prefixCls}-full-process`]: lastStepHasStatus > (current || 0),
    }, className);
    React.useEffect(() => {
        setMobileCurrentStep(current || 0);
    }, [current]);
    const steps = (React.createElement(RcSteps, Object.assign({ icons: icons }, restProps, { size: size, labelPlacement: labelPlacement, direction: getDirection(), stepIcon: stepIconRender, prefixCls: prefixCls, iconPrefix: iconPrefix, className: stepsClassName, onChange: handleChange, current: current }), children));
    const mobileHeader = (React.createElement(Row, { align: "middle", gutter: [8, 4] },
        React.createElement(Col, { flex: "none " },
            React.createElement(Button, { type: "text", disabled: !mobileCurrentStep, shape: "circle", onClick: handlePreStep, icon: React.createElement(LeftOutlined, null) })),
        React.createElement(Col, { flex: "auto" },
            React.createElement("div", null,
                React.createElement(Typography.SubTitle, { level: 6, fontWeight: "medium", className: "space-mb-0" }, (_b = (_a = childStep[mobileCurrentStep || 0]) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.title)),
            React.createElement("div", null,
                React.createElement(Typography.Note, { level: 2, className: `space-mb-0 ${prefixCls}-subTitle` },
                    (mobileCurrentStep || 0) + 1,
                    "/",
                    numSteps))),
        React.createElement(Col, { flex: "none" },
            React.createElement(Button, { type: "text", shape: "circle", onClick: mobileToggle, icon: React.createElement(SortOutlined, null) })),
        React.createElement(Col, { span: 24 },
            React.createElement(Progress, { percent: (((mobileCurrentStep || 0) + 1) / numSteps) * 100, strokeWidth: 4, showInfo: false }))));
    const mobileVer2 = (React.createElement(AffixFC, { offsetTop: mobileTop || 0 },
        React.createElement("div", null,
            React.createElement("div", { className: `${prefixCls}-mobile-container ${mobileShowStep}` },
                React.createElement(Collapse, { onChange: mobileToggle, activeKey: mobileShowStep },
                    React.createElement(Collapse.Panel, { showArrow: false, header: mobileHeader, key: "1" },
                        React.createElement("div", null,
                            React.createElement(RcSteps, Object.assign({ icons: icons }, restProps, { size: size, labelPlacement: labelPlacement, direction: getDirection(), stepIcon: stepIconRender, prefixCls: prefixCls, iconPrefix: iconPrefix, className: stepsClassName, onChange: handleChange, current: mobileCurrentStep }), children))))),
            !!mobileShowStep && (React.createElement("div", { className: "ant-modal-mask", onClick: () => {
                    setMobileShowStep(0);
                } })))));
    return isMobile ? mobileVer2 : steps;
};
Steps.Step = RcSteps.Step;
Steps.defaultProps = {
    current: 0,
    responsive: true,
};
export default Steps;
